import { render, staticRenderFns } from "./SocialMediaButtons.vue?vue&type=template&id=575fb232&scoped=true"
import script from "./SocialMediaButtons.vue?vue&type=script&lang=ts"
export * from "./SocialMediaButtons.vue?vue&type=script&lang=ts"
import style0 from "./SocialMediaButtons.vue?vue&type=style&index=0&lang=scss"
import style1 from "./SocialMediaButtons.vue?vue&type=style&index=1&id=575fb232&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575fb232",
  null
  
)

export default component.exports